import styled from 'styled-components';
import {
  COLOR_BLUE,
  COLOR_BLUE_015,
  COLOR_BLUE_010,
  COLOR_BLUE_030,
  COLOR_GREEN,
} from '@common/assets/styles/colors';

export const MonthSelectorSC = styled.div`
  width: 240px;
  height: 32px;

  margin-left: auto;
  margin-right: auto;

  display: flex;
  justify-content: space-between;

  span.month-label {
    width: 156px;
    background-color: ${COLOR_BLUE_010};
    color: ${COLOR_BLUE};
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 20px;
    padding: 6px 16px;
    border-radius: 5px;
    text-align: center;
  }

  button.nav-btn {
    width: 32px;
    height: 100%;
    padding-left: 0;
    padding-right: 0;
    background-color: ${COLOR_BLUE_010};

    &:hover {
      background-color: ${COLOR_BLUE_015};
    }

    &:first-child {
      padding-right: 1px;

      svg {
        transform: rotate(180deg);
      }
    }

    &:not(:first-child) {
      padding-left: 1px;
    }
  }
`;

export const DaySelectorSC = styled.div<{ firstDayOfMonth: number }>`
  .day-labels,
  .days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
  }

  div.day-labels {
    margin-top: 32px;

    > span {
      color: ${COLOR_BLUE_030};
      text-align: center;
    }
  }

  .days-loading {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      width: 30px;
      height: 30px;
    }
  }

  .days {
    button.day {
      /* max-width: 48px; */
      height: 48px;
      width: 36px;

      padding-left: 0;
      padding-right: 0;
      text-align: center;

      background-color: transparent;
      color: ${COLOR_BLUE};

      display: flex;
      flex-direction: column;

      &:first-child {
        grid-column: ${({ firstDayOfMonth }) => firstDayOfMonth};
      }

      &.weekend {
        color: ${COLOR_BLUE_030};
      }

      &.not-available {
        cursor: not-allowed;
      }

      &:hover,
      &:active,
      &.selected {
        background-color: ${COLOR_BLUE_010};
      }

      .dots {
        display: flex;
        position: absolute;
        bottom: 5px;

        .green-dot {
          margin-top: 4px;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background-color: ${COLOR_GREEN};
        }
      }
    }
  }
`;

export default styled.div`
  width: 100%;
`;
